export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST"
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS"
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR"
export const FORGOT_PASSWORD_VALIDATION_ERROR = "FORGOT_PASSWORD_VALIDATION_ERROR"
export const FORGOT_PASSWORD_CLEAR = "FORGOT_PASSWORD_CLEAR"
